import { defineRule } from '../define-rule'
import { assertNotNullish, assertPrimitives } from '@/libs/utils/assertion.util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type CharBetweenRuleConstructorParams = BaseRuleConstructorParams<{
  min: number
  max: number
}>

export const charBetween = defineRule(
  'char_between',
  ({ config, errorMessage }: CharBetweenRuleConstructorParams) => {
    const { min, max } = config
    const error = errorMessage ?? false
    assertNotNullish(min)
    assertNotNullish(max)
    return (value) => {
      try {
        assertPrimitives(value, 'string', 'number')
        return (String(value).length >= min && String(value).length <= max) || error
      } catch (e) {
        console.error('Error while executing dateIsValid', e)
        return error
      }
    }
  }
)
